import http from '@/httpAxios';

const getMemberPoint: (
  storeId: string,
  mobile: string,
  country: string
) => any = (storeId, mobile, country) => {
  const url = `/online/v2/member/point/info?country=${country}`;

  return http.get(url, {
    storeId,
    mobile,
  });
};

const checkPhoneIsFullMember: (
  mobile: string,
  country: string,
  storeUuid: string,
  redirectToken: string
) => any = (mobile, country, storeUuid, redirectToken) => {
  const url = 'online/v2/member/check-phone-is-full-member';
  return http.get(url, { mobile, country, storeUuid, redirectToken });
};

const sendMemberCaptcha: (
  mobile: string,
  country: string,
  storeUuid: string,
  redirectToken: string
) => any = (mobile, country, storeUuid, redirectToken) => {
  const url = 'online/v2/member/send-member-captcha';
  return http.get(url, { mobile, country, storeUuid, redirectToken });
};

const registerMemberCaptcha: (captcha, captchaToken: string) => any = (
  captcha,
  captchaToken
) => {
  const url = 'online/v2/member/register-member-captcha';
  return http.get(
    url,
    { captcha },
    {
      headers: {
        Authorization: `Bearer ${captchaToken}`,
      },
    }
  );
};

const verifyMemberCaptcha: (captcha, captchaToken: string) => any = (
  captcha,
  captchaToken
) => {
  const url = 'online/v2/member/verify-member-captcha';
  return http.get(
    url,
    { captcha },
    {
      headers: {
        Authorization: `Bearer ${captchaToken}`,
      },
    }
  );
};

const logoutMemberToken: (token: string) => any = (token) => {
  const url = 'online/v2/member/logout-member-token';
  return http.get(
    url,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const getMemberInfo: (token: string, storeUuid: string) => any = (
  token,
  storeUuid
) => {
  const url = `online/v2/member/get-member-info`;
  return http.get(
    url,
    {
      storeUuid,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const updateMemberInfo: (memberInfo: any, token: string) => any = (
  memberInfo,
  token
) => {
  const url = 'online/v2/member/update-member-info';
  return http.put(
    url,
    {
      ...memberInfo,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const deleteMember: (token: string) => any = (token) => {
  const url = 'online/v2/member/delete-member';
  return http.delete(
    url,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const getUserTerms: (storeUuid: string) => any = async (storeUuid) => {
  const url = 'online/v2/user-terms/get-user-terms';
  return http.get(url, { storeUuid });
};

const MemberInfoService = {
  getMemberPoint,
  checkPhoneIsFullMember,
  sendMemberCaptcha,
  registerMemberCaptcha,
  verifyMemberCaptcha,
  getMemberInfo,
  updateMemberInfo,
  deleteMember,
  logoutMemberToken,
  getUserTerms,
};

export default MemberInfoService;
